import React, { memo } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { brandRadarUrl } from "../../util/url";

import "./BrandRadarButton.css";

function RadarIcon() {
  return (
    <svg
      className="BrandRadarButton-icon"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <g transform="translate(0.831 1.114)">
        <path
          d="M17.2177 11.0414C16.8391 12.4544 16.0952 13.7428 15.0609 14.7771C14.0265 15.8115 12.7381 16.5554 11.3252 16.934C9.9122 17.3126 8.42447 17.3126 7.01151 16.934C5.59855 16.5554 4.31014 15.8115 3.27578 14.7771C2.24142 13.7428 1.49755 12.4544 1.11895 11.0414C0.740349 9.62845 0.74035 8.14072 1.11895 6.72776C1.49755 5.3148 2.24142 4.02639 3.27578 2.99203C4.31014 1.95767 5.59855 1.21381 7.01151 0.835207"
          stroke="black"
          strokeWidth="1.67"
          strokeLinecap="round"
        />
      </g>
      <g transform="translate(9.164 1.114)">
        <path
          d="M2.99184 0.835207C4.40481 1.21381 5.69322 1.95767 6.72758 2.99203C7.76194 4.02639 8.5058 5.3148 8.8844 6.72777L0.835019 8.88459L2.99184 0.835207Z"
          fill="black"
          stroke="black"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g transform="translate(4.581 4.737)">
        <path
          d="M9.84549 6.44862C9.63726 7.22575 9.22814 7.93438 8.65924 8.50327C8.09034 9.07217 7.38172 9.4813 6.60459 9.68953C5.82746 9.89776 5.00921 9.89776 4.23208 9.68953C3.45495 9.4813 2.74632 9.07217 2.17743 8.50327C1.60853 7.93437 1.1994 7.22575 0.991173 6.44862C0.782942 5.67149 0.782942 4.85324 0.991173 4.07611C1.1994 3.29898 1.60853 2.59036 2.17743 2.02146C2.74633 1.45256 3.45495 1.04344 4.23208 0.835207"
          stroke="black"
          strokeWidth="1.67"
          strokeLinecap="round"
        />
      </g>
      <g transform="translate(8.330 8.330)">
        <path
          d="M2.50167 1.66833C2.50167 1.77777 2.48011 1.88613 2.43823 1.98724C2.39635 2.08834 2.33497 2.18021 2.25759 2.25759C2.18021 2.33497 2.08834 2.39635 1.98724 2.43823C1.88613 2.48011 1.77777 2.50167 1.66833 2.50167C1.5589 2.50167 1.45054 2.48011 1.34943 2.43823C1.24833 2.39635 1.15646 2.33497 1.07908 2.25759C1.0017 2.18021 0.940313 2.08834 0.898434 1.98724C0.856555 1.88613 0.835 1.77777 0.835 1.66833C0.835 1.5589 0.856555 1.45054 0.898434 1.34943C0.940313 1.24833 1.0017 1.15646 1.07908 1.07908C1.15646 1.0017 1.24833 0.940313 1.34943 0.898434C1.45054 0.856555 1.5589 0.835 1.66833 0.835C1.77777 0.835 1.88613 0.856555 1.98724 0.898434C2.08834 0.940313 2.18021 1.0017 2.25759 1.07908C2.33497 1.15646 2.39635 1.24833 2.43823 1.34943C2.48011 1.45054 2.50167 1.5589 2.50167 1.66833Z"
          stroke="black"
          strokeWidth="1.67"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}

function LogoIcon() {
  return (
    <svg
      className="BrandRadarButton-logo"
      viewBox="0 0 84 12"
      fill="none"
      aria-label="brand radar"
      role="img"
    >
      <path
        d="M5.16367 11.9566C4.02509 11.9566 3.12707 11.5244 2.48561 10.7719V11.7005H0V0.09375H2.56579V3.93597C3.19121 3.24758 4.0732 2.84735 5.17971 2.84735C7.48891 2.84735 9.2529 4.57635 9.2529 7.36196C9.2529 10.0035 7.66531 11.9566 5.16367 11.9566ZM2.56579 7.40999C2.56579 8.9949 3.30347 9.93945 4.58636 9.93945C5.88529 9.93945 6.62296 8.9949 6.62296 7.40999C6.62296 5.80906 5.88529 4.88053 4.58636 4.88053C3.30347 4.88053 2.56579 5.80906 2.56579 7.40999ZM10.002 11.7005V3.1035H12.4876V4.20813C13.0489 3.40767 13.9148 2.97542 15.0374 2.97542C15.1978 2.97542 15.3581 2.99143 15.5024 3.00744V5.29676H14.877C13.2092 5.29676 12.5678 5.76103 12.5678 7.34595V11.7005H10.002ZM18.6107 11.9246C16.7505 11.9246 15.4515 10.82 15.4515 9.10697C15.4515 7.58609 16.4938 6.70557 18.5465 6.48145L20.2303 6.30535C20.5992 6.27333 20.9038 6.2253 21.1765 6.17727V6.01718C21.1765 5.2007 20.6794 4.72043 19.7492 4.72043C18.771 4.72043 18.3541 5.2007 18.2418 5.68098H15.7402C15.9487 3.77588 17.456 2.81533 19.7332 2.81533C22.2509 2.81533 23.6942 3.984 23.6942 6.11324V9.65129C23.6942 10.2276 23.7744 11.0601 23.8385 11.7005H21.5293L21.4491 10.7239C20.8236 11.5404 19.8455 11.9246 18.6107 11.9246ZM17.9532 9.07495C17.9532 9.65129 18.4343 10.0675 19.22 10.0675C20.3266 10.0675 21.1765 9.39514 21.1765 8.3065V7.81022C20.9038 7.9383 20.5992 8.01834 20.2303 8.06637L18.8672 8.21046C18.5786 8.24248 17.9532 8.41856 17.9532 9.07495ZM24.9319 11.7005V3.1035H27.4175V4.04804C27.9949 3.23157 28.8448 2.81533 29.9031 2.81533C31.9237 2.81533 33.2066 4.06405 33.2066 6.19328V11.7005H30.6409V6.52948C30.6409 5.56892 30.1277 4.86452 29.1815 4.86452C28.2033 4.86452 27.4977 5.58493 27.4977 6.9297V11.7005H24.9319ZM37.9462 11.9566C35.4446 11.9566 33.841 10.0035 33.841 7.36196C33.841 4.57635 35.6209 2.84735 37.9302 2.84735C39.0367 2.84735 39.9187 3.24758 40.5441 3.93597V0.09375H43.1098V11.7005H40.6243V10.7719C39.9829 11.5244 39.0847 11.9566 37.9462 11.9566ZM36.487 7.40999C36.487 8.9949 37.2246 9.93945 38.5075 9.93945C39.8064 9.93945 40.5441 8.9949 40.5441 7.40999C40.5441 5.80906 39.8064 4.88053 38.5075 4.88053C37.2246 4.88053 36.487 5.80906 36.487 7.40999ZM47.2524 11.7005V3.19955H48.872V4.41625C49.4173 3.55175 50.2672 3.07148 51.4217 3.07148C51.5821 3.07148 51.7265 3.08749 51.8547 3.1035V4.60837H51.3576C49.6738 4.60837 48.9201 5.34479 48.9201 7.2659V11.7005H47.2524ZM55.0616 11.9086C53.2174 11.9086 51.9827 10.836 51.9827 9.17101C51.9827 7.71417 52.9128 6.91369 54.9494 6.70557L56.5529 6.52948C57.1624 6.46544 57.5312 6.41742 57.8039 6.35338V6.03319C57.8039 4.99259 57.1142 4.30419 55.8634 4.30419C54.5966 4.30419 54.0032 4.96057 53.875 5.66497H52.2232C52.3996 3.95198 53.7948 2.95941 55.8795 2.95941C58.1406 2.95941 59.4556 4.12808 59.4556 6.0492V9.89142C59.4556 10.4197 59.5358 11.1562 59.5998 11.7005H58.0283L57.916 10.5158C57.3388 11.4283 56.3285 11.9086 55.0616 11.9086ZM53.6504 9.23505C53.6504 10.0035 54.3399 10.5958 55.4144 10.5958C56.7615 10.5958 57.8039 9.73134 57.8039 8.21046V7.47402C57.4831 7.63412 57.0661 7.74618 56.5529 7.81022L55.0135 7.98632C54.7249 8.01834 53.6504 8.22647 53.6504 9.23505ZM64.4717 11.9246C62.0662 11.9246 60.4626 10.0355 60.4626 7.442C60.4626 4.78447 62.1303 2.99143 64.4717 2.99143C65.7225 2.99143 66.7328 3.51973 67.4063 4.40024V0.09375H69.074V11.7005H67.4383V10.4838C66.7649 11.3963 65.7385 11.9246 64.4717 11.9246ZM62.1945 7.45801C62.1945 9.36312 63.1727 10.5478 64.7924 10.5478C66.412 10.5478 67.4063 9.36312 67.4063 7.45801C67.4063 5.5369 66.412 4.36823 64.7924 4.36823C63.1727 4.36823 62.1945 5.5369 62.1945 7.45801ZM73.3116 11.9086C71.4674 11.9086 70.2326 10.836 70.2326 9.17101C70.2326 7.71417 71.1627 6.91369 73.1993 6.70557L74.803 6.52948C75.4123 6.46544 75.7811 6.41742 76.0538 6.35338V6.03319C76.0538 4.99259 75.3643 4.30419 74.1134 4.30419C72.8465 4.30419 72.2531 4.96057 72.1249 5.66497H70.4732C70.6495 3.95198 72.0447 2.95941 74.1294 2.95941C76.3905 2.95941 77.7055 4.12808 77.7055 6.0492V9.89142C77.7055 10.4197 77.7857 11.1562 77.8499 11.7005H76.2783L76.1661 10.5158C75.5887 11.4283 74.5784 11.9086 73.3116 11.9086ZM71.9005 9.23505C71.9005 10.0035 72.59 10.5958 73.6643 10.5958C75.0114 10.5958 76.0538 9.73134 76.0538 8.21046V7.47402C75.7331 7.63412 75.3162 7.74618 74.803 7.81022L73.2635 7.98632C72.9748 8.01834 71.9005 8.22647 71.9005 9.23505ZM79.2578 11.7005V3.19955H80.8774V4.41625C81.4227 3.55175 82.2726 3.07148 83.4271 3.07148C83.5875 3.07148 83.7319 3.08749 83.8601 3.1035V4.60837H83.3631C81.6792 4.60837 80.9255 5.34479 80.9255 7.2659V11.7005H79.2578Z"
        fill="black"
      />
    </svg>
  );
}

function ArrowIcon() {
  return (
    <svg
      className="BrandRadarButton-arrow"
      viewBox="0 0 6 10"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M0.183058 0.183058C0.427136 -0.0610194 0.82277 -0.0610194 1.06685 0.183058L5.23351 4.34972C5.47759 4.5938 5.47759 4.98944 5.23351 5.23351L1.06685 9.40018C0.82277 9.64426 0.427136 9.64426 0.183058 9.40018C-0.0610194 9.1561 -0.0610194 8.76047 0.183058 8.51639L3.90783 4.79162L0.183058 1.06685C-0.0610194 0.82277 -0.0610194 0.427136 0.183058 0.183058Z"
        fill="black"
        fillOpacity="0.3"
      />
    </svg>
  );
}

/**
 * 브랜드 레이더 진입 버튼
 * @param className 추가 클래스
 * @param brandName 진입할 대상 브랜드명 (없으면 기본 /brand-radar)
 * @returns {JSX.Element}
 * @constructor
 */
function BrandRadarButton({ className = "", brandName }) {
  return (
    <Link
      to={brandRadarUrl(brandName)}
      className={`BrandRadarButton ${className}`.trim()}
      aria-label="브랜드 레이더 열기"
    >
      <RadarIcon />
      <LogoIcon />
      <span className="BrandRadarButton-badge">NEW</span>
      <ArrowIcon />
    </Link>
  );
}

BrandRadarButton.propTypes = {
  className: PropTypes.string,
  brandName: PropTypes.string,
};

export default memo(BrandRadarButton);
